import React from "react"
import { Dialog, IconButton } from "@mui/material"
import { X } from "lucide-mui"

interface PhotoPreviewProps {
  imageUrl: string | null
  onClose: () => void
}

const STYLES = {
  container: "relative bg-black",
  closeButton: "absolute top-4 right-4 z-10",
  closeIcon: "w-6 h-6",
  image: "w-full h-auto max-h-[90vh] object-contain",
} as const

const PhotoPreview: React.FC<PhotoPreviewProps> = ({ imageUrl, onClose }) => {
  return (
    <Dialog
      open={!!imageUrl}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      data-testid="settings-venue-photo-preview-dialog"
    >
      <div className={STYLES.container}>
        <IconButton
          onClick={onClose}
          className={STYLES.closeButton}
          sx={{ color: "white" }}
          data-testid="settings-venue-photo-preview-btn-close"
        >
          <X className={STYLES.closeIcon} />
        </IconButton>
        {imageUrl && (
          <img src={imageUrl} alt="Preview" className={STYLES.image} data-testid="settings-venue-photo-preview-image" />
        )}
      </div>
    </Dialog>
  )
}

export default PhotoPreview
